import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960.160167,0 L28,932.160167 L107.000407,1010.93741 L960.160167,157.777649 L1813.31993,1010.93741 L1892.20875,932.160167 L960.160167,0 Z M1573.85273,1027.34004 L1573.85273,1808.4175 L1238.99367,1808.4175 L1238.99367,1250.50503 L681.19277,1250.50503 L681.19277,1808.4175 L346.445284,1808.4175 L346.445284,1027.34004 L234.751206,1027.34004 L234.751206,1920 L681.19277,1920 L1238.99367,1920 L1685.43523,1920 L1685.43523,1027.34004 L1573.85273,1027.34004 Z M1127.52275,1362.08752 L1127.52275,1808.52909 L792.775266,1808.52909 L792.775266,1362.08752 L1127.52275,1362.08752 Z M960.126693,692.603708 C1021.72023,692.603708 1071.70919,742.592666 1071.70919,804.186203 C1071.70919,865.779741 1021.72023,915.768699 960.126693,915.768699 C898.533155,915.768699 848.544197,865.779741 848.544197,804.186203 C848.544197,742.592666 898.533155,692.603708 960.126693,692.603708 Z M1183.29168,804.186203 C1183.29168,681.110711 1083.20219,581.021212 960.126693,581.021212 C837.0512,581.021212 736.961702,681.110711 736.961702,804.186203 C736.961702,927.261696 837.0512,1027.35119 960.126693,1027.35119 C1083.20219,1027.35119 1183.29168,927.261696 1183.29168,804.186203",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconHomeLine = /*#__PURE__*/function (_Component) {
  _inherits(IconHomeLine, _Component);

  var _super = _createSuper(IconHomeLine);

  function IconHomeLine() {
    _classCallCheck(this, IconHomeLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconHomeLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconHome",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconHomeLine.displayName = "IconHomeLine";
  return IconHomeLine;
}(Component);

IconHomeLine.glyphName = 'home';
IconHomeLine.variant = 'Line';
IconHomeLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconHomeLine;
export { IconHomeLine };